import React from 'react';
import { Card, InputNumber, Row } from 'antd';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import UtinaCard from 'components/UtinaCard';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type IncomeProps = {
  form: FormInstance;
};

const IncomeCard = (props: IncomeProps) => {
  return (
    <Card bordered style={{ backgroundColor: '#f7f7f7' }} title={<GetLabel label="income" style={{fontWeight:'bold',paddingLeft:15}} />}>
      
      <Card>
        <Row gutter={16}>
          <UtinaCard comcode="employment" level={5} lg={8} additionalAttribute>
            <FormInput col xs={20} lg={20} name="tpemployer" />
            <FormInput col xs={20} lg={20} name="tpemloyertel">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpemployeraddress" />
          </UtinaCard>

          <UtinaCard comcode="income" level={5} lg={8} additionalAttribute>
            <FormInput col xs={20} lg={20} name="tpmonthlyincome">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpothersincome">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpfamilybenefits">
              <InputNumber />
            </FormInput>
          </UtinaCard>

          <UtinaCard comcode="expanses" level={5} lg={6} additionalAttribute>
            <FormInput col xs={20} name="tpotherloan">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} name="tpothersexpense">
              <InputNumber />
            </FormInput>
          </UtinaCard>
        </Row>
      </Card>
    </Card>
  );
};

export default IncomeCard;
